<script setup>
import { withQuery } from "ufo";
import moment from "moment-timezone";

moment.tz.setDefault("Asia/Jakarta");

const deleteDialog = ref(false);

definePage({
  meta: {
    layout: "default",
  },
});
const route = useRoute();
const router = useRouter();

const pageTitle = "Parameter Setting System";

const breadCrumbs = [
  {
    title: "Dashboard",
    to: "/admin/dashboard",
  },
  {
    title: "Master Data",
    to: null,
  },
  {
    title: pageTitle,
    to: "/admin/parameter-setting-system",
  },
  {
    title: "1001",
    to: null,
  },
];

const { data: dataQuery } = await useApi(
  withQuery("/cms/parameter/" + route.params.id, {
    method: "GET",
  })
);
const data = dataQuery ? dataQuery.value?.data : [];
</script>

<template>
  <VBreadcrumbs :items="breadCrumbs" class="px-0 pt-0 pb-5" />
  <h4 class="text-h4 my-4">{{ pageTitle }} Detail</h4>
  <VCard
    border
    class="v-card-data"
    title="Parameter Setting System Information"
  >
    <template #append>
      <div class="d-flex gap-4">
        <VBtn
          :to="{
            path: '/admin/parameter-setting-system/update/' + route.params.id,
          }"
          color="primary"
        >
          <VIcon icon="tabler-pencil" start />
          Edit {{ pageTitle }}
        </VBtn>
      </div>
    </template>
    <VTable class="text-no-wrap" density="compact">
      <tbody>
        <tr>
          <td>Parameter No.</td>
          <td>{{ data.parameterNo }}</td>
        </tr>
        <tr>
          <td>Name</td>
          <td>{{ data.name }}</td>
        </tr>
        <tr>
          <td>Key</td>
          <td>{{ data.key }}</td>
        </tr>
        <tr>
          <td>Value</td>
          <td>{{ data.value }}</td>
        </tr>
        <tr>
          <td>Description</td>
          <td>
            {{ data.description }}
          </td>
        </tr>
        <tr>
          <td>Check type</td>
          <td>{{ data.checkType }}</td>
        </tr>
        <tr>
          <td>Length of value</td>
          <td>{{ data.maxLengthValue }}</td>
        </tr>
        <tr>
          <td>Last update</td>
          <td>
            {{ data.updatedAt ? moment(data.updatedAt).format("LLL") : null }}
          </td>
        </tr>
      </tbody>
    </VTable>
  </VCard>
  <div class="mx-auto text-center">
    <VBtn
      :to="{ path: '/admin/parameter-setting-system' }"
      class="mt-5 mx-auto text-center"
      color="secondary"
    >
      <VIcon icon="tabler-refresh" start />
      Back to {{ pageTitle }} List
    </VBtn>
  </div>
</template>
